import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import IconPattern from '@mlb/react-patterns/components/Icon/icon';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

/** Styled Components */
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin: auto;
`;

const Title = styled.h1`
    font-size: 20px;
    font-weight: 600;
    color: ${COLORS.mlbWhite};
    margin: 0;
    font-family: ${FONTS.primaryFont};
`;

/** Override a tag styling here, just because base-site overrides it with mlb-league class on body tag */
const Message = styled.p`
    font-size: 16px;
    font-weight: normal;
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    margin: 0;
    margin-bottom: 15px;
    text-align: center;
    a {
        color: ${COLORS.linkBlueOnDark};
    }
    a:hover {
        color: ${COLORS.linkBlueOnDarkHover};
    }
`;


const Icon = styled(IconPattern)`

    use {
        symbol {
            path {
                &:first-of-type, &:nth-child(2), &:nth-child(3), &:nth-child(4) {
                    stroke:  ${COLORS.mlbWhite};
                }
                &:nth-child(5) {
                    stroke:${COLORS.mlbWhite};
                }
                &:nth-child(6) {
                    fill: ${COLORS.mlbWhite};
                }
            }
        }
    }
    circle {
        stroke: ${COLORS.mlbWhite};
    }
    margin-bottom: 16px;
`;

const StatusTemplate = ({
    title,
    message,
    button,
}) => {

    return (
        <Wrapper>
            <Icon name={'sad-baseball'} width={57} fill={COLORS.mlbWhite}/>
            <Title>
                {title}
            </Title>
            <Message>
                {message}
            </Message>
            {button}
        </Wrapper>
    );

};

StatusTemplate.propTypes = {
    title: PropTypes.string,
    button: PropTypes.element,
    message: PropTypes.node,
};

StatusTemplate.defaultProps = {
    title: '',
    button: null,
    message: null,
};

export default StatusTemplate;
